import router from '../router';

export default function logUserOut(store) {
  if (store === undefined) {
    // eslint-disable-next-line no-param-reassign
    store = this.$store;
  }

  const { client } = store.state;

  store.commit('userData', null);
  store.commit('client', null);
  localStorage.removeItem('token');

  if (client && client.slug) {
    router.push({
      name: 'client-login',
      params: { client_slug: client.slug },
    });
  } else {
    router.push({ name: 'login' });
  }
}
